export const mapInputGroups = (selectedInputGroup, selectedSubInputs, input) => {
  let index = '';

  const getLtcIndex = (value) => {
    if (value) {
      const maxSelections = 4;
      return value.length >= maxSelections ? maxSelections : value.length;
    }
    return value;
  };

  input.forEach((question) => {
    let mappedIndex = 'N';
    const currentInput = selectedInputGroup.find((selectedInput) => selectedInput.name === question.name);

    // Get any selected sub input for the current primary input
    const currentSubInput = selectedSubInputs.find((selectedInput) => selectedInput.name === question.name);

    if (currentInput) {
      let itemSelectedValue;
      // HACK: ltc group has a special mapping from the selected values to the option in the input object
      if (question.name === 'ltc_group') itemSelectedValue = getLtcIndex(currentInput.selectedValue.itemKey);
      else {
        // If subinput exists, then get it's itemkey, else get itemkey from the primary input
        itemSelectedValue =
          (currentSubInput && currentSubInput.selectedValue.categoryId) || currentInput.selectedValue.itemKey;
      }

      // only if no sub input exists for the current primary input
      const selectedAnswer =
        !currentSubInput && question.options.find((option) => option.position === itemSelectedValue);
      if (selectedAnswer || currentSubInput) mappedIndex = (currentSubInput && itemSelectedValue) || selectedAnswer.id;
    }

    const startPos = question.indexPos.min;
    const endPos = question.indexPos.max;
    const length = endPos - startPos + 1;
    const paddedValue = ('0'.repeat(length) + mappedIndex).slice(-length);

    const newIndexGroup = index.split('');
    newIndexGroup.splice(startPos, length, paddedValue);
    index = newIndexGroup.join('');
  });
  return index;
};
